const defaultUI = {
	activeTab : 'textcontrol',
	loading : false
}
const ui =(state = defaultUI, action) => {
	if(action.type=='SET ACTIVE TAB'){
		state = Object.assign({},state,{activeTab: action.tabName})
	}
	if(action.type == 'LOADING'){
		state = Object.assign({},state,{loading: action.status})
	}
	if(action.type == 'SHARE'){
		state = Object.assign({},state,{shareTo: action.to})
	}
	return state;
}

export default ui;